import React from 'react';
import { QuestionDependencies, QuestionForm } from './components';
import { useQuestionDetails } from './hooks';

const QuestionDetails = () => {
  const {
    dependencies,
    translations,
    questionHelpers: {
      form,
      question,
      isQuestionLoading,
      currentLanguage,
      initialValues,
      isFormDirty,
      visibilityType,
      questionText,
      handleEditQuestion,
      handleResetForm,
      setCurrentLanguage,
    },
  } = useQuestionDetails();

  return (
    <div className="pt-2 px-4 pb-8">
      <QuestionForm
        form={form}
        question={question}
        isFormDirty={isFormDirty}
        initialValues={initialValues}
        currentLanguage={currentLanguage}
        translations={translations?.items}
        isQuestionLoading={isQuestionLoading}
        hasDependencies={!!dependencies?.sources?.length}
        handleResetForm={handleResetForm}
        handleEditQuestion={handleEditQuestion}
        setCurrentLanguage={setCurrentLanguage}
      />
      <QuestionDependencies
        form={form}
        isFormDirty={isFormDirty}
        questionText={questionText}
        dependencies={dependencies}
        visibilityType={visibilityType}
        answerType={question?.answerType}
        handleEditQuestion={handleEditQuestion}
      />
    </div>
  );
};

export default QuestionDetails;
